import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
    dashboardMenu,
    mastersMenu,
    outletsMenu,
    menu,
    contentMgtMenu,
    couponsMenu,
    systemMenu,
    automationMenu,
    CustomerSupportMgt,
    CancellationRequest,
    PurchaseMenu,
    reportsMenu,
    transactionsMenu,
    userLevelMenu,
    materialMgtMenu,
    assetMgtMenu,
    FranchiseEnquiryMenu,
    subscriptionMenu,
    summariesMenu,
    userMgtMenu,
    supportMenu,
    requestsIntendMenu,
    deliveryAppMenu
} from "../data/Menu";

class Sidebar extends Component {
    toggleFooterMenu = (e) => {
        e.preventDefault();
        let parent = e.target.closest(".sidebar");
        parent.classList.toggle("footer-menu-show");
    }

    render() {
        const { access, userEmail} = this.props;
        // const userEmail = localStorage.getItem("email");
        console.log("Access or Permissions :", access, "user email :", userEmail);
        
        return (
            <div className="sidebar">
                <div className="sidebar-header">
                    <Link to="/dashboard" className="sidebar-logo">xpanse</Link>
                </div>
                <PerfectScrollbar className="sidebar-body pb-3" ref={ref => this._scrollBarRef = ref}>
                    <SidebarMenu 
                        onUpdateSize={() => this._scrollBarRef.updateScroll()} 
                        access={access}
                        userEmail={userEmail}
                    />
                </PerfectScrollbar>
                <div className="sidebar-footer mt-2">
                    {/* <h6>Hello</h6> */}
                    ... footer content ...
                </div>
            </div>
        )
    }
}

class SidebarMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeGroup: null,
        };
    }

    // Debug method to log permissions and menu access
    debugPermissions = (categoryName, menuData) => {
        const { access } = this.props;
        console.log(`=== DEBUG: ${categoryName} ===`);
        console.log('User permissions:', access);
        
        menuData.forEach(menuItem => {
            const componentName = this.getComponentNameFromMenuItem(menuItem);
            const hasAccess = this.hasMenuItemAccess(menuItem);
            console.log(`Menu item: ${menuItem.label}, Component: ${componentName}, Has access: ${hasAccess}`);
        });
    }

    // Check if user has access to any component in a category
    hasCategoryAccess = (categoryName, menuData) => {
        const { access } = this.props;
        
        // If access is undefined or empty, show all categories
        if (!access || access.length === 0) {
            console.log(`No access restrictions, showing category: ${categoryName}`);
            return true;
        }
        
        // Check if any menu item in this category has access
        const hasAccess = menuData.some(menuItem => {
            return this.hasMenuItemAccess(menuItem);
        });

        console.log(`Category ${categoryName} access: ${hasAccess}`);
        
        // Debug output for outlets specifically
        if (categoryName === "Outlets") {
            this.debugPermissions(categoryName, menuData);
        }
        
        return hasAccess;
    };

    // Check if user has access to a specific menu item
    hasMenuItemAccess = (menuItem) => {
        const { access } = this.props;
        
        // If access is undefined or empty, show all menu items
        if (!access || access.length === 0) return true;
        
        const componentName = this.getComponentNameFromMenuItem(menuItem);

        // Special case: If it's "ALL REPORTS", check if user has ANY report permission
        if (componentName === "AllReports") {
            const hasReportAccess = access.some(permission => {
                const permComponentName = permission.split(':')[0].trim();
                // Check if this is any kind of report permission
                return permComponentName.endsWith('Report') || 
                    permComponentName.endsWith('Summary') ||
                    permComponentName.includes('Transaction');
            });
            return hasReportAccess;
        }
        
        // Check if user has any permission for this component (any action)
        const hasAccess = access.some(permission => {
            const permComponentName = permission.split(':')[0].trim();
            return permComponentName.toLowerCase() === componentName.toLowerCase();
        });

        return hasAccess;
    };

    // Get component name from menu item
    getComponentNameFromMenuItem = (menuItem) => {
        console.log("Menu Item :", menuItem);

        // First try to use the component property if it exists
        if (menuItem.component) {
            return menuItem.component;
        }
        
        
        // Convert menu label to proper component name format
        const label = menuItem.label.toLowerCase();
        
        // Special cases that don't follow simple conversion rules
        const specialCases = {
            "all reports": "AllReports",
            "outlet mgt": "Outlet",
            "outlet user mgt": "OutletUser", 
            "kiosk user mgt": "KioskUser",
            "customer support mgt": "CustomerSupportMgt",
            "menu ingredients": "MenuIngredients",
            "addon group": "AddonGroup",
            "addon allocation": "AddonAllocation",
            
        };
        
        // Check if this is a special case
        if (specialCases[label]) {
            return specialCases[label];
        }
        
        // Default conversion: remove spaces and capitalize first letter of each word
        // Example: "category mgt" -> "CategoryMgt"
        const words = label.split(' ');
        const camelCaseWords = words.map(word => 
            word.charAt(0).toUpperCase() + word.slice(1)
        );
        
        return camelCaseWords.join('');
    };

    populateMenu = (menuItems) => {
        // Filter menu items based on access
        const accessibleMenuItems = menuItems.filter(menuItem => 
            this.hasMenuItemAccess(menuItem)
        );

        // If no menu items are accessible, return null
        if (accessibleMenuItems.length === 0) {
            return null;
        }

        return (
            <ul className="nav nav-sidebar">
                {accessibleMenuItems.map((m, key) => {
                    const submenu = m.submenu?.map((sm, k) => (
                        <NavLink to={sm.link} className="nav-sub-link" key={k}>
                            {sm.label}
                        </NavLink>
                    ));

                    return (
                        <li key={key} className="nav-item" style={{ fontSize: "13px" }}>
                            {!submenu ? (
                                <NavLink to={m.link} className="nav-link">
                                    <i className={m.icon}></i> <span>{m.label}</span>
                                </NavLink>
                            ) : (
                                <div
                                    onClick={this.toggleSubMenu}
                                    className="nav-link has-sub"
                                >
                                    <i className={m.icon}></i> <span>{m.label}</span>
                                </div>
                            )}
                            {submenu && <nav className="nav nav-sub">{submenu}</nav>}
                        </li>
                    );
                })}
            </ul>
        );
    };

    toggleMenu = (menuName) => {
        this.setState(
            (prevState) => ({
                activeGroup: prevState.activeGroup === menuName ? null : menuName,
            }),
            () => this.props.onUpdateSize()
        );
    };

    toggleSubMenu = (e) => {
        e.preventDefault();
        const parent = e.target.closest(".nav-item");
        let node = parent.parentNode.firstChild;

        while (node) {
            if (node !== parent && node.nodeType === Node.ELEMENT_NODE) {
                node.classList.remove("show");
            }
            node = node.nextElementSibling || node.nextSibling;
        }

        parent.classList.toggle("show");
        this.props.onUpdateSize();
    };

    renderGroup = (label, menuData, nameKey) => {
        const { userEmail } = this.props;
        
        // Hide "Requests Indent" for specific email
        if (label === "Requests Indent" && userEmail === "contact@xpansecafe.com") {
            console.log(`Hiding ${label} for email: ${userEmail}`);
            return null;
        }

        // Check if user has access to this category
        if (!this.hasCategoryAccess(label, menuData)) {
            return null;
        }

        // If there's only one menu item, handle it as a direct link
        if (menuData.length === 1) {
            const singleMenuItem = menuData[0];
            // Check if user has access to this single menu item
            if (!this.hasMenuItemAccess(singleMenuItem)) {
                return null;
            }
            
            return (
                <div className="nav-group">
                    <NavLink 
                        to={singleMenuItem.link} 
                        className="nav-label" 
                        style={{ fontWeight: "bolder", cursor: "pointer" }}
                        activeClassName="active"
                    >
                        {label}
                    </NavLink>
                </div>
            );
        }

        // For multiple items, use the existing expandable group behavior
        const isOpen = this.state.activeGroup === nameKey;
        return (
            <div className={`nav-group ${isOpen ? "show" : ""}`} style={{ cursor: 'pointer' }}>
                <div
                    className="nav-label"
                    style={{ fontWeight: "bolder" }}
                    onClick={() => this.toggleMenu(nameKey)}
                >
                    {label}
                </div>
                {isOpen && this.populateMenu(menuData)}
            </div>
        );
    };

    render() {
        return (
            <React.Fragment>
                {this.renderGroup("Dashboard", dashboardMenu, "dashboard")}
                {this.renderGroup("Reports", reportsMenu, "reports")}
                {this.renderGroup("Food Delivery App", deliveryAppMenu, "deliveryApp")}
                {this.renderGroup("Admin Users", userMgtMenu, "adminUserMgt")}
                {this.renderGroup("Material", materialMgtMenu, "materialMgt")}
                {this.renderGroup("Requests Indent", requestsIntendMenu, "requestsIndent")}
                {this.renderGroup("Outlets", outletsMenu, "outlets")}
                {this.renderGroup("Menu", menu, "menu")}
                {this.renderGroup("Purchase", PurchaseMenu, "purchase")}
                {this.renderGroup("Support & Enquiry", supportMenu, "support")}
                {this.renderGroup("User Levels", userLevelMenu, "userLevels")}
                {this.renderGroup("Content", contentMgtMenu, "content")}
                {this.renderGroup("Coupons & Offers", couponsMenu, "coupons")}
                {this.renderGroup("Subscription", subscriptionMenu, "Subscription")}
                {this.renderGroup("System preference", systemMenu, "system")}
            </React.Fragment>
        );
    }
}

// Map Redux state to component props
const mapStateToProps = (state) => ({
    access: state.login.access,
    userEmail: state.login.email // Assuming email is stored in state.login.email
});

// Connect component to Redux store and export it
export default connect(mapStateToProps)(Sidebar);


// import React, { Component } from "react";
// import { Link, NavLink } from "react-router-dom";
// import PerfectScrollbar from "react-perfect-scrollbar";
// import userAvatar from "../assets/img/img1.jpg";
// import {
//     dashboardMenu,
//     mastersMenu,
//     outletsMenu,
//     menu,
//     contentMgtMenu,
//     couponsMenu,
//     systemMenu,
//     automationMenu,
//     CustomerSupportMgt,
//     CancellationRequest,
//     PurchaseMenu,
//     reportsMenu,
//     transactionsMenu,
//     userLevelMenu,
//     materialMgtMenu,
//     assetMgtMenu,
//     FranchiseEnquiryMenu,
//     subscriptionMenu,
//     summariesMenu,
//     userMgtMenu,
//     supportMenu
//     // pagesMenu,
//     // uiElementsMenu
// } from "../data/Menu";

// export default class Sidebar extends Component {
//     toggleFooterMenu = (e) => {
//         e.preventDefault();

//         let parent = e.target.closest(".sidebar");
//         parent.classList.toggle("footer-menu-show");
//     }

//     render() {
//         const { access } = this.props; // Now access comes from props

//         return (
//             <div className="sidebar">
//                 <div className="sidebar-header">
//                     <Link to="https://xpansecafe.com/" className="sidebar-logo">xpanse</Link>
//                 </div>
//                 <PerfectScrollbar className="sidebar-body pb-3" ref={ref => this._scrollBarRef = ref}>
//                     <SidebarMenu onUpdateSize={() => this._scrollBarRef.updateScroll()} />
//                 </PerfectScrollbar>
//                 <div className="sidebar-footer mt-2">
//                     <div className="sidebar-footer-top">
//                         <div className="sidebar-footer-thumb">
//                             {/* <img src={userAvatar} alt="" /> */}
//                             <img src={require('../pages/Profile.png')} />
//                         </div>
//                         <div className="sidebar-footer-body">
//                             <h6><Link to="../pages/profile.html">XPANSE ADMIN</Link></h6>
//                             <p>Admin</p>
//                         </div>
//                         <Link onClick={this.toggleFooterMenu} to="" className="dropdown-link"><i className="ri-arrow-down-s-line"></i></Link>
//                     </div>
//                     <div className="sidebar-footer-menu">
//                         <nav className="nav">
//                             <Link to=""><i className="ri-edit-2-line"></i> Edit Profile</Link>
//                             <Link to="/view"><i className="ri-profile-line"></i> View Profile</Link>
//                         </nav>
//                         <hr />
//                         <nav className="nav">
//                             <Link to=""><i className="ri-question-line"></i> Help Center</Link>
//                             <Link to=""><i className="ri-lock-line"></i> Privacy Settings</Link>
//                             <Link to="system-preference/settings"><i className="ri-user-settings-line"></i> Account Settings</Link>
//                             <Link to=""><i className="ri-logout-box-r-line"></i> Log Out</Link>
//                         </nav>
//                     </div>
//                 </div>
//             </div>
//         )
//     }
// }

// class SidebarMenu extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             activeGroup: null, // Track the currently open menu group
//         };
//     }

//     populateMenu = (menuItems) => {
//         return (
//             <ul className="nav nav-sidebar">
//                 {menuItems.map((m, key) => {
//                     const submenu = m.submenu?.map((sm, k) => (
//                         <NavLink to={sm.link} className="nav-sub-link" key={k}>
//                             {sm.label}
//                         </NavLink>
//                     ));

//                     return (
//                         <li key={key} className="nav-item" style={{ fontSize: "13px" }}>
//                             {!submenu ? (
//                                 <NavLink to={m.link} className="nav-link">
//                                     <i className={m.icon}></i> <span>{m.label}</span>
//                                 </NavLink>
//                             ) : (
//                                 <div
//                                     onClick={this.toggleSubMenu}
//                                     className="nav-link has-sub"
//                                 >
//                                     <i className={m.icon}></i> <span>{m.label}</span>
//                                 </div>
//                             )}
//                             {submenu && <nav className="nav nav-sub">{submenu}</nav>}
//                         </li>
//                     );
//                 })}
//             </ul>
//         );
//     };

//     toggleMenu = (menuName) => {
//         this.setState(
//             (prevState) => ({
//                 activeGroup: prevState.activeGroup === menuName ? null : menuName,
//             }),
//             () => this.props.onUpdateSize()
//         );
//     };

//     toggleSubMenu = (e) => {
//         e.preventDefault();

//         const parent = e.target.closest(".nav-item");
//         let node = parent.parentNode.firstChild;

//         while (node) {
//             if (node !== parent && node.nodeType === Node.ELEMENT_NODE) {
//                 node.classList.remove("show");
//             }
//             node = node.nextElementSibling || node.nextSibling;
//         }

//         parent.classList.toggle("show");
//         this.props.onUpdateSize();
//     };

//     renderGroup = (label, menuData, nameKey) => {
//         // If there's only one menu item, handle it as a direct link
//         if (menuData.length === 1) {
//             const singleMenuItem = menuData[0];
//             return (
//                 <div className="nav-group">
//                     <NavLink 
//                         to={singleMenuItem.link} 
//                         className="nav-label" 
//                         style={{ fontWeight: "bolder", cursor: "pointer" }}
//                         activeClassName="active"
//                     >
//                         {label}
//                     </NavLink>
//                 </div>
//             );
//         }

//         // For multiple items, use the existing expandable group behavior
//         const isOpen = this.state.activeGroup === nameKey;
//         return (
//             <div className={`nav-group ${isOpen ? "show" : ""}`} style={{ cursor: 'pointer' }}>
//                 <div
//                     className="nav-label"
//                     style={{ fontWeight: "bolder" }}
//                     onClick={() => this.toggleMenu(nameKey)}
//                 >
//                     {label}
//                 </div>
//                 {isOpen && this.populateMenu(menuData)}
//             </div>
//         );
//     };

//     render() {
//         return (
//             <React.Fragment>
//                 {this.renderGroup("Dashboard", dashboardMenu, "dashboard")}
//                 {/* {this.renderGroup("Masters", mastersMenu, "masters")} */}
//                 {this.renderGroup("Reports", reportsMenu, "reports")}
//                 {this.renderGroup("Admin User Mgt", userMgtMenu, "adminUserMgt")}
//                 {this.renderGroup("Material Management", materialMgtMenu, "materialMgt")}
//                 {/* {this.renderGroup("Automation", automationMenu, "automation")} */}
//                 {this.renderGroup("Outlets", outletsMenu, "outlets")}
//                 {this.renderGroup("Menu", menu, "menu")}
//                 {this.renderGroup("Purchase / Outwards", PurchaseMenu, "purchase")}
//                 {/* {this.renderGroup("Transactions", transactionsMenu, "transactions")} */}
//                 {this.renderGroup("Support", supportMenu, "support")}
//                 {/* {this.renderGroup("Customer Support", CustomerSupportMgt, "support")} */}
//                 {/* {this.renderGroup("Cancellation Request", CancellationRequest, "cancelReq")} */}
//                 {this.renderGroup("User Levels", userLevelMenu, "userLevels")}
//                 {this.renderGroup("Content Management", contentMgtMenu, "content")}
//                 {this.renderGroup("Coupons Management", couponsMenu, "coupons")}
//                 {this.renderGroup("Subscription", subscriptionMenu, "Subscription")}
//                 {this.renderGroup("System preference", systemMenu, "system")}
//                 {/* {this.renderGroup("Asset Management", assetMgtMenu, "assets")} */}
//                 {/* {this.renderGroup("Franchise Enquiry", FranchiseEnquiryMenu, "franchise")} */}
//                 {/* {this.renderGroup("Summaries", summariesMenu, "summaries")} */}
//             </React.Fragment>
//         );
//     }
// }

// window.addEventListener("click", function (e) {
//     // Close sidebar footer menu when clicked outside of it
//     let tar = e.target;
//     let sidebar = document.querySelector(".sidebar");
//     if (!tar.closest(".sidebar-footer") && sidebar) {
//         sidebar.classList.remove("footer-menu-show");
//     }

//     // Hide sidebar offset when clicked outside of sidebar
//     if (!tar.closest(".sidebar") && !tar.closest(".menu-link")) {
//         document.querySelector("body").classList.remove("sidebar-show");
//     }
// });

// window.addEventListener("load", function () {
//     let skinMode = localStorage.getItem("sidebar-skin");
//     let HTMLTag = document.querySelector("html");

//     if (skinMode) {
//         HTMLTag.setAttribute("data-sidebar", skinMode);
//     }
// });